import { GenericCollectionFactory } from "../../_generics";
import { GENERIC_IDS } from "../../_constants/generics.constants";

export const ClockinWorkShiftStore = GenericCollectionFactory(GENERIC_IDS.CLOCKINS_WORK_SHIFT, "uid");